import { MandalEntity } from './mandal.entity';
import { Injectable, Inject } from '@nestjs/common';
import { getdistrictDTO, MandalDTO, MandalStatusDTO, } from './dto/mandal.dto';
import { Repository, Raw, getConnection, TreeRepository } from 'typeorm';
import { InjectRepository } from '@nestjs/typeorm';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { MandalResponseModel,  } from './dto/mandal-response.model';
import { AllMandalResponseModel } from './dto/all-mandal-response.model';
import { MandalStatusWiseResponseModel } from './dto/mandal-status-response.model';

@Injectable()
export class MandalService {
    constructor(
        @InjectRepository(MandalEntity)
        private mandalRespository: Repository<MandalEntity>,
    ) {}

    async createMandal(queryParams, mandalDto:MandalDTO, isUpdate:boolean,request:Request): Promise<MandalResponseModel>{
        const response = new MandalResponseModel();
        try{
            if (!isUpdate){
                const MandalEntity= await this.getMandalDetailsWithoutRealtions(mandalDto.mandalName);
                if(MandalEntity){
                    throw new ErrorResponse(11104,'Mandal already exists');
                } else {
                    if (queryParams.apiVersion == 1) {
                        const savedMandal = await this.mandalRespository.save(mandalDto);
                        if(savedMandal){
                            response.status = true;
                            response.data = savedMandal;
                            response.statusCode = 50000;
                            response.internalMessage = 'Mandal created successfully';
                            response.intlCode = 11100;
                        } else {
                            throw new ErrorResponse(11106,'Mandal not created');
                        }
                    } else {
                        const savedMandal = await this .mandalRespository.save(mandalDto);
                        if (savedMandal){
                            response.status = true;
                            response.data = savedMandal;
                            response.statusCode = 50000;
                            response.internalMessage = 'Mandal created successfully';
                            response.intlCode = 11100;
                        } else {
                            throw new ErrorResponse(11106,'Mandal not created');
                        }
                    }
                }
            } else {
                if (queryParams.apiVersion == 1) {
                    const updatedMandal = await this.mandalRespository.update(mandalDto.Id,mandalDto);
                    const updatedData = await this.mandalRespository.findOne({
                        where:{Id:mandalDto.Id}
                    });
                    if (updatedMandal) {
                        response.status = true;
                        response.data = updatedData;
                        response.statusCode = 50000;
                        response.internalMessage = 'Mandal updated successfully';
                        response.intlCode  = 111000;
                    } else{
                        throw new ErrorResponse (11106,'Mandal not updated');
                    }
                } else {
                    const updatedMandal = await this.mandalRespository.update(mandalDto.Id,mandalDto);
                    const updatedData = await this.mandalRespository.findOne({
                        where:{Id:mandalDto.Id}
                    });
                    if(updatedMandal) {
                        response.status = true;
                        response.data =updatedData;
                        response.statusCode = 50000;
                        response.internalMessage = 'Mandal updated successfully';
                        response.intlCode = 11100;
                    }else{
                        throw new ErrorResponse (11106,'Mandal not updated');
                        
                    }
                }
            }
            return response;
        }catch (error) {
            throw error;
        }
    }
    
    async getMandalDetailsWithoutRealtions(mandalName: string): Promise<MandalEntity> {
        const MandalResponse = await this. mandalRespository.findOne({
            where : {mandalName: Raw(alias => `UPPER(mandal_name) = '${mandalName.toLocaleUpperCase()}'`), status: true},
        });
        if (MandalResponse) {
            return MandalResponse;
        }else{
            return null;
        }
    }

    async getAllMandals(queryParams, request): Promise<AllMandalResponseModel> {
        const response = new AllMandalResponseModel();
        try{
            if (queryParams.apiVersion == 1) {
                const mandalData = await this.mandalRespository.find({
                    order: {createdAt: 'DESC'}
                });
                if (mandalData) {
                    response.status = true;
                    response.data = mandalData;
                    response.statusCode = 50000;
                    response.internalMessage = 'Mandal retrived successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Mandal record not found');
                }
            } else {
                const mandalData = await this.mandalRespository.find({
                    order:{createdAt: 'DESC'}
                });  
                if (mandalData) {
                    response.status = true;
                    response.data = mandalData;
                    response.statusCode = 50000;
                    response.internalMessage = 'Mandal retrieved successfully';
                    response.intlCode = 11108;
                } else{
                    throw new ErrorResponse(99998, 'Mandal record not found');
                }
            } 
            return response;
        } catch (err) {
            throw err;
        }
    }

    async getMandalByMandalName(queryParams, mandalName: string,request:Request): Promise<MandalResponseModel>{
        const response = new MandalResponseModel();
        try{
            if (queryParams.apiVersion == 1) {
                const mandalResponse = await this.mandalRespository.findOne({
                    where:{mandalName:Raw (alias => `UPPER (mandal_name)='${mandalName.toLocaleUpperCase()}'`)}
                });
                if (mandalResponse) {
                    response.status = true;
                    response.data = mandalResponse;
                    response.statusCode = 50000;
                    response.internalMessage = 'Mandal record found';
                    response.intlCode = 11107;
                } else {
                    throw new ErrorResponse (99998, 'Mandal record not found');
                }
            }else{
                const mandalResponse = await this.mandalRespository.findOne({
                    where:{mandalName: Raw (alias =>`UPPER(mandal_name) = '${mandalName.toLocaleUpperCase()}'`)}
                });
                if (mandalResponse) {
                    response.status = true;
                    response.data = mandalResponse;
                    response.statusCode = 50000;
                    response.internalMessage = 'Mandal record Found';
                    response.intlCode = 11107;
                } else {
                    throw new ErrorResponse (99998, 'Mandal record not found');
                }
            }
            return response ;
        } catch (error) {
            throw error;
        }
    }

    async getMandalByMandalId (queryParams , mandalId: number,request:Request): Promise<MandalResponseModel>{
        const response = new MandalResponseModel();
        try{
            if (queryParams.apiVersion == 1){
                const mandalResponse = await this.mandalRespository.findOne({
                    where:{Id: Raw(alias =>` id= '${mandalId}'`)}
                });
                if (mandalResponse) {
                    response.status = true;
                    response.data = mandalResponse;
                    response.statusCode = 50000;
                    response.internalMessage = 'Mandal record found';
                    response.intlCode = 11107;
                } else {
                    throw new ErrorResponse(99998, 'Mandal record not found');
                }
            } else{
                const mandalResponse = await this.mandalRespository.findOne({
                    where:{Id: Raw(alias =>`id= '${mandalId}'`)}
                });
                if (mandalResponse) {
                    response.status = true;
                    response.data = mandalResponse;
                    response.statusCode = 50000;
                    response.internalMessage = 'Mandal record found';
                    response.intlCode = 11107;
                } else {
                    throw new ErrorResponse(99998, 'Mandal record not found');
                }
            }
            return response;
        }catch(error){
            throw error;
        }
    }    
    
    async getAllActiveMandal(queryParams,request:Request): Promise<AllMandalResponseModel> {
        const response = new AllMandalResponseModel();
        try{
            if (queryParams.apiVersion == 1) {
                const mandalData = await this.mandalRespository.find({
                    where:{ status: true},
                    order: {createdAt: 'DESC'}
                });
                if (mandalData) {
                    response.status = true;
                    response.data = mandalData;
                    response.statusCode = 50000;
                    response.internalMessage = 'Mandal retrived successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Mandal record not found');
                }
            } else {
                const mandalData = await this.mandalRespository.find({
                    where :{status: true},
                    order:{createdAt: 'DESC'}
                });  
                if (mandalData) {
                    response.status = true;
                    response.data = mandalData;
                    response.statusCode = 50000;
                    response.internalMessage = 'Mandal retrieved successfully';
                    response.intlCode = 11108;
                } else{
                    throw new ErrorResponse(99998, 'Mandal record not found');
                }
            } 
            return response;
        } catch (err) {
            throw err;
        }
    }

    async getActiveMandalCount(queryParams,request:Request): Promise<MandalStatusWiseResponseModel>{
        const response = new MandalStatusWiseResponseModel();
        try{
            if (queryParams.apiVersion == 1) {
                const mandalStatusWiseCount = await getConnection()
                .createQueryBuilder()
                .select("Sum(IF(status = true, 1,0 )) as activeCount,Sum(IF(status = false ,1,0)) as inActiveCount, count(*) as cnt")
                .from(MandalEntity, "mandal")
                .orderBy('status','ASC')
                .getRawOne();
                if (mandalStatusWiseCount) {
                    response.status = true;
                    response.active = mandalStatusWiseCount.activeCount;
                    response.inActive = mandalStatusWiseCount.inActiveCount;
                    response.total = mandalStatusWiseCount.cnt;
                    response.statusCode = 50000;
                    response.internalMessage = 'Mandal retrived successfully';
                    response.intlCode = 11108;
                }  else {
                    throw new ErrorResponse(99998, 'Mandal not found');
                }                   
            } else{
                const mandalStatusWiseCount= await getConnection()
                .createQueryBuilder()
                .select("Sum(IF(status = true,1,0)) as activeCount,Sum(IF(status =false ,1,0)) as inActiveCount, count(*) as cnt")
                .from(MandalEntity,"mandal")
                .orderBy('mandal','ASC')
                .getRawOne();
                if (mandalStatusWiseCount) {
                    response.status = true;
                    response.active = mandalStatusWiseCount.activeCount;
                    response.inActive = mandalStatusWiseCount.inActiveCount;
                    response.total = mandalStatusWiseCount.cnt;
                    response.statusCode = 50000;
                    response.internalMessage = 'Mandal retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Mandal not found');
                }
            }
            return response;
        } catch (err) {
            throw err;
        }
    }

    async UpdateMandalStatus(queryParams,mandalStatusDto:MandalStatusDTO,request:Request):Promise<MandalResponseModel>{
        const response = new MandalResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                await this.mandalRespository.update(mandalStatusDto.Id,mandalStatusDto);
                const mandal = await this.mandalRespository.findOne({
                    where: { Id:mandalStatusDto.Id },
                });
                if (mandal) {
                    response.status = true;
                    response.data = mandal;
                    response.statusCode = 50000;
                    response.internalMessage = 'Mandal status updated successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Mandal status update failed');
                }
            } else {
                await this.mandalRespository.update(mandalStatusDto.Id,mandalStatusDto);
                const mandal = await this.mandalRespository.findOne({
                    where: { Id:mandalStatusDto.Id },
                });
                if (mandal) {
                    response.status = true;
                    response.data = mandal;
                    response.statusCode = 50000;
                    response.internalMessage = 'Mandal status updated successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Mandal status update failed');
                } 
            }      
            return response;
        } catch (error) {
          throw error;
        }
    }

    async getmandalbydistrictid(queryParams, getdistrictDTO:getdistrictDTO, request: Request): Promise<AllMandalResponseModel> {
        const response = new AllMandalResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                const activeTypes = await this.mandalRespository.find({
                   
                    where: {districtId:getdistrictDTO.districtId,  status: true},
                    //relations:['district'],
                    order: { createdAt: 'DESC' }
                });
                if(activeTypes) {
                    response.status = true;
                    response.data = activeTypes;
                    response.statusCode = 50000;
                    response.internalMessage = 'data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
            } else {
                const activeTypes = await this.mandalRespository.find({
                   
                    where: {districtId:getdistrictDTO.districtId,  status: true},
                    //relations:['district'],
                    order: { createdAt: 'DESC' }
                });
                if(activeTypes) {
                    response.status = true;
                    response.data = activeTypes;
                    response.statusCode = 50000;
                    response.internalMessage = 'data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

                     
}
             
                    
